import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import apiIdValue from '../../services/api-id-value-service'
import utils from '../../utils'
import _ from 'lodash'
const BASE_PATH = '/lottustech/relatorios'
const crud = build(validate, BASE_PATH)
const prefix = 'crudLivroCaixa'

const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.abrirRelatorio = (
  dataIni,
  dataFin,
  unidade,
  isDetal,
  hasTotaliz,
  formasPagamento,
  tiposSepulturas,
  usuariosBaixa,
  contas
) => {
  let params = {
    dataInicial: dataIni,
    dataFinal: dataFin,
    unidades: unidade,
    detalhado: isDetal,
    hasTotalizadores: hasTotaliz,
    formasPagamentos: formasPagamento,
    tiposSepulturas: tiposSepulturas,
    usuariosBaixa,
    contas,
  }
  return (dispatch, getState) => {
    const path = BASE_PATH + `/livrocaixa`
    return apiService.post(path, params).then((response) => {
      const win = window.open(response.data)
      if (win) {
        win.focus()
      }
    })
  }
}

actions.carregarTiposSepulturas = (unidade) => {
  const params = {
    unidades: unidade,
  }
  return (dispatch, getState) => {
    dispatch(actions.setField('carregandoTiposSepulturas', true))
    const path = BASE_PATH + `/tipossepulturas/`
    const state = getState()[`crudExumacoesRelatorioState`]
    return apiService
      .post(path, params)
      .then((response) => {
        if (state.currentRecord.tiposSepulturas.length > 0) {
          let itensRemover = []
          state.currentRecord.tiposSepulturas.forEach((tipo) => {
            const obj = utils.findObjectInArray(response.data, 'value', tipo.value)
            if (!obj) {
              itensRemover.push(tipo.value)
            }
          })
          itensRemover.forEach((itemRemover) => {
            utils.removeObjectFromArray(state.currentRecord.tiposSepulturas, 'value', itemRemover)
          })
        }
        dispatch(actions.setField('opcoesTiposSepulturas', response.data))
      })
      .finally(() => {
        dispatch(actions.setField('carregandoTiposSepulturas', false))
      })
  }
}

actions.carregarContasCorrentes = (unidade) => {
  return (dispatch, getState) => {
    dispatch(actions.setField('carregandoContasCorrentes', true))
    const unidadesSelecionadas = Array.isArray(unidade) ? unidade : unidade ? [unidade] : []
    const idsUnidades = unidadesSelecionadas.map((item) => item.id).filter((id) => id > 0)

    if (_.isEmpty(idsUnidades)) {
      return apiIdValue
        .getContasCorrentes(-1)
        .then((response) => {
          dispatch(actions.setField('opcoesContasCorrentes', response.data))
        })
        .finally(() => {
          dispatch(actions.setField('carregandoContasCorrentes', false))
        })
    }

    const requests = idsUnidades.map((idUnidade) => apiIdValue.getContasCorrentes(idUnidade))
    return Promise.all(requests)
      .then((responses) => {
        const contasCorrentesConcat = responses.reduce((acc, response) => acc.concat(response.data || []), [])
        const contasCorrentes = _.uniqBy(
          contasCorrentesConcat,
          (contaCorrente) => contaCorrente.id
        )
        dispatch(actions.setField('opcoesContasCorrentes', contasCorrentes))
      })
      .finally(() => {
        dispatch(actions.setField('carregandoContasCorrentes', false))
      })
  }
}

actions.carregarUsuariosBaixa = (unidade) => {
  return (dispatch, getState) => {
    dispatch(actions.setField('carregandoUsuariosBaixa', true))
    const params = unidade && unidade.length > 0 ? unidade : []
    const path = `/lottustech/usuarios/baixa`
    return apiService
      .post(path, params)
      .then((response) => {
        dispatch(actions.setField('opcoesUsuarioBaixa', response.data))
      })
      .finally(() => {
        dispatch(actions.setField('carregandoUsuariosBaixa', false))
      })
  }
}
export { types, actions }
